import * as Business from '../business';
import * as User     from '../user';
import { compose }   from 'redux';
import { connect }   from 'react-redux';
import Badge         from '../components/badge';
import Button        from '../components/primary_button';
import currency      from 'currency.js';
import Navbar        from '../components/navbar';
import NotFoundPage  from '../components/not_found_page';
import React         from 'react';
import SwitchControl from '../components/switch_control';


export default connect(
  (state, { businessID }) => ({
    business:         Business.getBusiness(state, businessID),
    paymentsSettings: Business.getPaymentsSettings(state, businessID),
    isAdmin:          User.isAdmin(state, businessID)
  }),
  (dispatch, { businessID }) => ({
    savePaymentsEnabled: compose(dispatch, Business.setPaymentsEnabled, enabled => ({ businessID, enabled })),
    saveTips:            compose(dispatch, Business.setTips, enabled => ({ businessID, enabled }))
  })
)(PaymentsPage);


export function PaymentsPage({ business, saveTips, savePaymentsEnabled, isAdmin, paymentsSettings }) {
  const isPaymentsAvailable = paymentsSettings?.available;
  const isPaymentsEnabled   = paymentsSettings?.enabled;
  const isPaymentsLiveMode  = paymentsSettings?.liveMode;
  const isTipsEnabled       = paymentsSettings?.tipsEnabled;
  const stripeURL           = paymentsSettings?.stripeURL;
  const fees                = paymentsSettings?.fees;

  if (business && (!isPaymentsAvailable || !isAdmin))
    return <NotFoundPage/>;

  return (
    <React.Fragment>
      {business && <Navbar title="Payments"/>}
      {business && (
        <div className="page-content payments-settings-page">
          {!isPaymentsLiveMode && (<TestModeDescription {...{ stripeURL }}/>)}
          <PaymentsEnabledAndTipsSwitches {...{
            isPaymentsEnabled,
            isPaymentsLiveMode,
            isTipsEnabled,
            saveTips,
            savePaymentsEnabled
          }}/>
          {isPaymentsLiveMode && isPaymentsEnabled && (<CreditCardFees {...fees}/>)}
        </div>
      )}
    </React.Fragment>
  );
}


function TestModeDescription({ stripeURL }) {
  return (
    <React.Fragment>
      <div className="list block test-mode-description">
        <Badge {...{ color: 'orange', text: 'Test Mode' }}/>
        <p>Did you know? Businesses prefer Broadly Payments because 90% of customers pay the same day they are invoiced.</p>
        <p>Learn how to use Broadly to get paid on time by sending test payment requests. Here’s how:</p>
        <ul>
          <li>Add yourself as a contact</li>
          <li>Click the Send Payment Request button (<ReviewRequestIcon/>)</li>
          <li>Check your text messages or email, click the link, and try to pay the invoice</li>
        </ul>
      </div>
      <ul className="list block">
        <li className="list-group-title">Connect your bank account</li>
        <li>
          <p>Once you’re ready to start receiving real payments and deposits through Broadly, connect your bank account by clicking the button below.</p>
          <p>The button will redirect you to a new page, where you will be able to complete the connection in a few simple steps.</p>
        </li>
        <li><Button href={stripeURL} label="Connect your bank account" external/></li>
      </ul>
    </React.Fragment>

  );
}


function CreditCardFees({ percentage = 0, fixed = '0.00' }) {
  const fixedAmount = currency(fixed);

  if (!!percentage || !!fixedAmount.intValue) {
    return (
      <section name="creditCardFees" className="block">
        <p>
          There is a
          {!!percentage && ` ${percentage}%`}
          {!!percentage && !!fixedAmount.intValue && ' +'}
          {!!fixedAmount.intValue && ` ${fixedAmount.format(true)}`} transaction fee.
          These fees will apply across all payment methods and will be deducted from your customer&apos;s payment amount.
        </p>
      </section>
    );
  } else
    return null;
}


function PaymentsEnabledAndTipsSwitches({ isTipsEnabled, isPaymentsEnabled, isPaymentsLiveMode, saveTips, savePaymentsEnabled }) {
  return (
    <div className="list block">
      <ul>
        <PaymentsEnabled {...{
          save: savePaymentsEnabled,
          isPaymentsLiveMode,
          isPaymentsEnabled
        }}/>
        {isPaymentsEnabled && (
          <Tips {...{ isTipsEnabled, save: saveTips }}/>
        )}
      </ul>
    </div>
  );
}


function ReviewRequestIcon() {
  return (
    <span className="link icon-only">
      <i className="icon icons8-requested-payment"/>
    </span>
  );
}


function PaymentsEnabled({ isPaymentsLiveMode, isPaymentsEnabled, save }) {
  const description = isPaymentsLiveMode ? '' : 'Your account is in Test Mode.';

  return (
    <SwitchItem
      label="Enable Payments"
      description={description}
      checked={isPaymentsEnabled}
      save={value => save(value)}/>
  );
}


function Tips({ isTipsEnabled, save }) {
  const description = isTipsEnabled ? 'You have tips enabled' : 'You have tips disabled';

  return (
    <SwitchItem
      label="Tips"
      description={description}
      checked={isTipsEnabled}
      save={value => save(value)}/>
  );
}


function SwitchItem({ label, description, checked, save }) {
  return (
    <li className="item-content switch-item">
      <div className="item-inner">
        <div className="item-title">
          <span>{label}</span>
          <div className="item-footer">{description}</div>
        </div>
        <div className="item-after">
          <SwitchControl {...{ checked, save }}/>
        </div>
      </div>
    </li>
  );
}
